<template>
  <span class="article-type-icon">
    <a-icon :icon="icon" />
  </span>
</template>

<script>
export default {
  name: "ArticleTypeIcon",
  props: {
    type: {
      type: String,
      default: "Commentary",
      validate: ( val ) => [
        "Commentary",
        "Research",
        "Case Study",
        "Review",
        "Educator in Practice",
        "Video",
      ].includes( val ),
    },
  },
  computed: {
    icon () {
      let result;

      switch ( this.type ) {
      case "Video":
        result = "fa:light:tv";
        break;

      case "Educator in Practice":
        result = "fa:light:graduation-cap";
        break;

      case "Review":
        result = "fa:light:file-alt";
        break;

      case "Case Study":
        result = "fa:light:file-chart-pie";
        break;

      case "Research":
        result = "fa:light:chart-bar";
        break;

      case "Commentary":
      default:
        result = "fa:regular:comment-alt-dots";
        break;
      }

      return result;
    },
  },
};
</script>
